import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Route, Switch, Redirect } from "react-router-dom";
import DashboardNew from "../components/dashboard-new/Dashboard";
import Footer from "../components/footer/Footer";
import loadable from "@loadable/component";
import AppContext from "../context/Context";
import DirectDebitReport from "../components/reports/Donation/DirectDebitReport";
import { getconfigData } from "./service";
import PublisherList from "../components/Publisher/PublisherList";
import './layout.css'
import Help from "../components/Help/Help";
import ChatBot from "../components/ChatBot/ChatBot";
import AskAi from "../components/new_Dashboard/AskAI/AskAI";
import SideBar from "./sidebar";
import Dashboard from "../components/_dashboard";
import UploadWidget from "../components/common/UploadWidget";

const DashboardRoutes = loadable(() => import("./routes"));

const DashboardLayout = ({ location }) => {
  const currentPath = window.location.pathname;
  const [showHelp, setShowHelp] = useState(false);
  const [showFaqOption, setShowFaqOption] = useState(false);
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);
  const { isFluid } = useContext(AppContext);
  const role = localStorage.getItem('role_id')
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarHovered, setSidebarHovered] = useState(false);
  let storedTopLevelRoutes = [];

  try {
    const parsedRoutes = JSON.parse(localStorage.getItem("routes") || "[]");
    storedTopLevelRoutes = Array.isArray(parsedRoutes) ? parsedRoutes : [];
  } catch (error) {
    storedTopLevelRoutes = [];
  }

  const hasAnalyticsAccess = storedTopLevelRoutes.includes("Analytics");

  const authPaths = ["/ForgotPassword", "/login", "/pub/forgotPassword", "/confirm-publisher"];
  const shouldHideSidebar = authPaths.some(p => currentPath.startsWith(p));

  const isLoged = localStorage.getItem("isLoged") === "true";
  const onboardingCompleted = localStorage.getItem("onboarding_completed");
  const isPublisher = role === "5" || role === "21";

  if (isLoged && isPublisher && onboardingCompleted === "false" && !localStorage.getItem("superadmin") && !authPaths.some(p => location.pathname.startsWith(p)) && !location.pathname.startsWith('/reset/') && location.pathname !== "/") {
    return <Redirect to="/" />;
  }
  const forgott_style = shouldHideSidebar ? "none" : undefined;

  const clearLocalStorage = async () => {
    Object.keys(localStorage).forEach((key) => {
      if (key !== "existingPublishers") {
        localStorage.removeItem(key);
      }
    });

    if (!authPaths.some(p => currentPath.startsWith(p)) && !currentPath.startsWith('/reset/')) {
      window.location.href = "/login";
    } else if (currentPath.startsWith('/reset/')) {
      const token = currentPath.split('/').pop();
      window.location.href = `/reset/${token}`;
    }

  }

  useEffect(() => {
    tokenValidation()
  }, []);

  const tokenValidation = async () => {
    DashboardRoutes.preload();
    if (!authPaths.some(p => currentPath.startsWith(p)) && !currentPath.startsWith('/reset/')) {
      console.log('currentPath', currentPath);
      try {
        setConfiguration()
      } catch (error) {
        clearLocalStorage();
      }

    }
  }

  const setConfiguration = async () => {
    getconfigData(localStorage.getItem("pub_id"))
      .then(async (data) => {
        localStorage.setItem(
          "channelConfig",
          JSON.stringify(data?.data?.channels)
        );
        localStorage.setItem(
          "publisherConfig",
          JSON.stringify(data?.data?.pub_config)
        );

        let publisherConfig = data?.data?.pub_config;
        const sessionExpiry = publisherConfig.find(
          (item) => item.key_name === "session_expiry"
        );
        const sessionTimeout = (sessionExpiry && sessionExpiry.key_value ? sessionExpiry.key_value : 3600) * 1000; // 1 hour in milliseconds
        async function checkSessionTimeout() {
          const sessionStartTime = localStorage.getItem("sessionStartTime");
          if (sessionStartTime) {
            if (
              Date.now() - sessionStartTime > sessionTimeout
            ) {
              if (currentPath !== "/login") {
                localStorage.removeItem("channelConfig");
                localStorage.removeItem("publisherConfig");
                localStorage.removeItem("isLoged");
                localStorage.removeItem("role_id");
                localStorage.removeItem("pub_id");
                localStorage.removeItem("currentPublisher");
                await clearLocalStorage();
              } // redirect to the login page
              else {
                await clearLocalStorage();
              }
            }
          }
          else {
            await clearLocalStorage();
            // window.location.href = "/login";
          }
        }
        function resetTimer() {
          clearTimeout(checkSessionTimeout);
          localStorage.setItem("sessionStartTime", Date.now());
          setTimeout(checkSessionTimeout, sessionTimeout);
        }

        // Call resetTimer() whenever the user performs any activity that indicates user interaction
        document.addEventListener("mousemove", resetTimer.bind(null, true));
        document.addEventListener("keypress", resetTimer.bind(null, true));
        document.addEventListener("scroll", resetTimer.bind(null, true));
        if (localStorage.getItem("isInitialLogin")) {
          resetTimer();
          localStorage.removeItem("isInitialLogin");
        } else {
          await checkSessionTimeout();
          resetTimer();
        }
      })
      .catch(async (e) => {
        await clearLocalStorage();
        return false;
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.pathname == '/login' || location.pathname.startsWith('/help/read_more/')) {
      setShowFaqOption(false)
    } else {
      setTimeout(() => {
        setShowFaqOption(true)
      }, 5000);

    }
  }, [location.pathname]);


  const toggleOverlay = () => {
    if (!isChatBotOpen) {
      setShowHelp(!showHelp); // Toggle the Help component
    }
  };
  const toggleChatBot = () => {
    if (isChatBotOpen) {
      const chatbotModal = document.querySelector('.chatbot-modal');
      if (chatbotModal) {
        chatbotModal.classList.add('closing');
        setTimeout(() => {
          setIsChatBotOpen(false);
        }, 300);
      }
    } else {
      setIsChatBotOpen(true);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.toggleChatBotGlobal = toggleChatBot;
      window.toggleHelpGlobal = toggleOverlay;
    }
    return () => {
      if (typeof window !== 'undefined') {
        if (window.toggleChatBotGlobal) {
          window.toggleChatBotGlobal = undefined;
        }
        if (window.toggleHelpGlobal) {
          window.toggleHelpGlobal = undefined;
        }
      }
    };
  }, [toggleChatBot, toggleOverlay]);

  let primaryDashboard =
    localStorage.getItem("role_id") == 7
      ? PublisherList
      : localStorage.getItem("role_id") == 13
        ? DirectDebitReport
        : localStorage.getItem("role_id") == 19
          ? () => <Redirect to="publisher-list" />
          : localStorage.getItem("role_id") == 20
            ? () => <Redirect to="/video-upload" />
            : localStorage.getItem("role_id") == 21
              ? () => <Redirect to="/operator/analytics" />
                  : localStorage.getItem("role_id") == 18
                    ? () => <Redirect to="/community/posts" />
                      : localStorage.getItem("role_id") == 15 && !hasAnalyticsAccess
                        ? () => <Redirect to="/videos/list" />
                          : Dashboard;

  const handleSidebarStateChange = (collapsed, hovered) => {
    setSidebarCollapsed(collapsed);
    setSidebarHovered(hovered);
  };

  return (
    <div className={`dashboard-layout ${isFluid ? "container-fluid" : "container"} ${shouldHideSidebar ? 'no-sidebar' : ''}`}>
      {!shouldHideSidebar &&
        <SideBar onStateChange={handleSidebarStateChange} />
      }
      <div id="main-content" className={`content ${sidebarCollapsed ? 'sidebar-collapsed-content' : ''} ${sidebarHovered ? 'sidebar-hovered-content' : ''} ${shouldHideSidebar ? 'no-sidebar' : ''}`}>
        <Switch>
          <Route path="/" exact component={primaryDashboard} />
          <Route path="/viewership" exact component={Dashboard} />
          <Route path="/subscription" exact component={Dashboard} />
          <Route path="/avod-performance" exact component={Dashboard} />
          <Route path="/dashboard-new" exact component={DashboardNew} />
          <DashboardRoutes />
        </Switch>
        {showHelp && !isChatBotOpen && (
          <div className={`help-component ${showHelp ? 'show' : 'hidden'}`}>
            <Help />
          </div>
        )}
        {showFaqOption && role != 7 && (
          <>
            <ChatBot toggleChatBot={toggleChatBot} isChatBotOpen={isChatBotOpen} />
            <AskAi showChatButton={true} />
          </>
        )}
        <Footer forgott_style={forgott_style} />
        <UploadWidget />
      </div>
    </div>
  );
};

DashboardLayout.propTypes = { location: PropTypes.object.isRequired };

export default DashboardLayout;
